module.exports = __webpack_public_path__ + "static/img/1365_phase_function_Paper_PointsHejduk_Prediction.9f4a6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1365_phase_function_Paper_PointsHejduk_Prediction.png
// module id = FaWc
// module chunks = 0